
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './slick.css';
import './slick-theme.css'
import "./App.css";

import Footer from "./components/Footer";
import Header from "./components/Header";

import Home from "./pages";
import Contact from "./pages/Contact";
import CAWI from "./pages/CAWI";
import CATI from "./pages/Cati";
import PhonToWeb from "./pages/PhoneToWeb";
import IDI from "./pages/IDI";
import Programming from "./pages/Programming";
import About from "./pages/About";
import FAQ from "./pages/FAQ";

function App() {
  var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
s1.async=true;
s1.src='https://embed.tawk.to/64e309dccc26a871b0306a84/1h8bdt2ev';
s1.charset='UTF-8';
s1.setAttribute('crossorigin','*');
s0.parentNode.insertBefore(s1,s0);
})();
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
  
        <Route path="/CAWI" element={<CAWI />} />
        <Route path="/phone-to-web" element={<PhonToWeb />} />
        <Route path="/CATI" element={<CATI />} />
        <Route path="/IDI" element={<IDI />} />
        <Route path="/programming&data-processing" element={<Programming />} />

        <Route path="/about-us" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        
       
      </Routes>
     <Footer />
    </Router>
  );
}

export default App;
